import {
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST,
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS,
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_FAIL,
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST,
  CREATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS,
  CREATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL,
  DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST,
  DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS,
  DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_FAIL,
  UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST,
  UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS,
  UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL,
  DELETE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST,
  DELETE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS,
  DELETE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL,
  LIST_PARTNER_SUMMARY_GENERATOR_REQUEST,
  LIST_PARTNER_SUMMARY_GENERATOR_SUCCESS,
  LIST_PARTNER_SUMMARY_GENERATOR_FAIL,
  CREATE_PARTNER_SUMMARY_GENERATOR_REQUEST,
  CREATE_PARTNER_SUMMARY_GENERATOR_SUCCESS,
  CREATE_PARTNER_SUMMARY_GENERATOR_FAIL,
  DETAIL_PARTNER_SUMMARY_GENERATOR_REQUEST,
  DETAIL_PARTNER_SUMMARY_GENERATOR_SUCCESS,
  DETAIL_PARTNER_SUMMARY_GENERATOR_FAIL
} from '../../constants/mcu-project-summary'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  mcuProjectSummaries: [],
  partnerSummaries: [],
  generalProjectSummary: {},
  partnerSummary: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectSummaries: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectSummaries: action?.dummy
      }
    case LIST_PARTNER_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loading: true }
    case LIST_PARTNER_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        partnerSummaries: action.payload,
        pageable: action.pageable
      }
    case LIST_PARTNER_SUMMARY_GENERATOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        partnerSummaries: action?.dummy
      }
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_REQUEST:
      return { ...state, loadingCreate: true }
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        mcuProjectSummaries: action.payload
      }
    case LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case CREATE_PARTNER_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_PARTNER_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_PARTNER_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case CREATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingCreate: true, generalProjectSummary: {} }
    case DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        generalProjectSummary: action.payload
      }
    case DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingPosition: true }
    case UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS:
      return { ...state, loadingPosition: false }
    case UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingPosition: false, error: action.payload }
    case DELETE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case DETAIL_PARTNER_SUMMARY_GENERATOR_REQUEST:
      return { ...state, loadingCreate: true, partnerSummary: {} }
    case DETAIL_PARTNER_SUMMARY_GENERATOR_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        partnerSummary: action.payload
      }
    case DETAIL_PARTNER_SUMMARY_GENERATOR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    default:
      return state
  }
}

export default mcuProjectReducer
